import React, { Fragment } from 'react';
import classnames from 'classnames';
import { connect } from 'unistore/react';

import { is768Query } from '~/core/scripts/mediaquery-helper';
import Icon from '~/core/scripts/components/Icon';
import actions from '~/scripts/state/actions';
import PartyBars from '~/scripts/PartyBars';
import { numberFormat } from '~/core/scripts/utils';

const TOOLTIP_WIDTH = 250;

function getHeader(data) {
  if (baseconfig.app.areaNameDisplay === 'simple') {
    return (
      <div className="tooltip-header">
        <div className="tooltip-title">{data.Wahlgebiet_Name}</div>
        <div className="tooltip-subtitle">{data.Wahlgebiet2_Name}</div>
      </div>
    );
  }

  return (
    <div className="tooltip-header">
      <div className="tooltip-title">{data.Wahlgebiet_Name}</div>
      <div className="tooltip-subtitle">{data.Wahlgebiet2_Name} <span className="light">{data.Wahlgebiet2_Name}</span></div>
    </div>
  )
}

const Tooltip = props => {
  const { data, pos, setTooltipData } = props;
  const isVisible = data !== null;
  const style = is768Query() ? { left: `${pos.x + 15}px`, top: `${pos.y - 75}px` } : {};
  const isInverted = pos.x + 35 + TOOLTIP_WIDTH >= window.innerWidth;
  const tooltipClass = classnames('tooltip-wrapper', 'is-active', { 'is-active': isVisible, invert: isInverted });

  if (!isVisible) {
    return null;
  }

  return (
    <div className={tooltipClass} style={{ ...style, borderColor: data.color }}>
      <div className="tooltip">
        <button className="btn close" onClick={() => setTooltipData(null)}>
          <Icon type="close" />
        </button>
        {getHeader(data)}
        {data.hasData ? (
          <Fragment>
            <div className="tooltip-body">
              <PartyBars
                items={data.partyItems}
                showComparison={false}
                areaId={data.Wahlgebiet_ID}
              />
            </div>
            <div className="tooltip-footer">
              Alle {numberFormat(data['Gültige.Stimmen'])} Stimmen bei Klick
            </div>
          </Fragment>
        ) : (
          <Fragment>
            <div className="tooltip-body">
              Keine Daten vorhanden
            </div>
          </Fragment>
        )}
      </div>
    </div>
  );
};

export default connect(state => ({
  pos: state.tooltipPos,
  data: state.tooltipData
}), actions)(Tooltip);
